import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";

const MembersChart = ({ routerProps, members }) => {
  const [chartData, setChartData] = useState([]);
  const [dateAmount, setDateAmount] = useState([]);

  const monthJoinedArray = [
    "2021-01",
    "2021-02",
    "2021-03",
    "2021-04",
    "2021-05",
    "2021-06",
    "2021-07",
    "2021-08",
    "2021-09",
    "2021-10",
    "2021-11",
    "2021-12",
    "2022-01",
    "2022-02",
    "2022-03",
    "2022-04",
    "2022-05",
    "2022-06",
  ];

  function filterByJoinDate(arrayOfDates) {
    const joinDateArray = [];
    arrayOfDates.forEach((date) => {
      const filteredMembers = members.filter((memb) => {
        return memb.user.date_joined.includes(date);
      });
      joinDateArray.push(filteredMembers.length);
    });
    setDateAmount(joinDateArray);
    return joinDateArray;
  }

  const memberChart = () => {
    setChartData({
      labels: [
        "Jan 21",
        "Feb 21",
        "Mar 21",
        "Apr 21",
        "May 21",
        "Jun 21",
        "Jul 21",
        "Aug 21",
        "Sep 21",
        "Oct 21",
        "Nov 21",
        "Dec 21",
        "Jan 22",
        "Feb 22",
        "Mar 22",
        "Apr 22",
        "May 22",
        "Jun 22",
      ],
      datasets: [
        {
          label: "Member Sign Up Data",
          data: filterByJoinDate(monthJoinedArray),
          backgroundColor: ["rgba(75, 192, 192, 0.6)"],
          borderWidth: 4,
        },
      ],
    });
  };

  useEffect(() => {
    memberChart();
  }, [members]);

  return (
    <div>
      <Line data={chartData} height={80} />
    </div>
  );
};
export default MembersChart;
